import styled from "styled-components";

export const ShowFormattedMathjaxWrapper = styled.div``;